import {EditsDispatcher} from '../core/dispatchers'
import {IEditsDispatcher, IPaylodAction, IActionDispatcher, ILayersDispatcher} from '../core/interfaces/dispatchers'
import {ISourceApplyEdits} from '../core/interfaces/services'
import {TypeKeyIdFeaturesPair, IStore, IdFeature} from '../core/interfaces/reducers'
import appConfig from '../reducers/appConfig'
import {FeatureStatus} from '../core/models'
import EditsActions from '../core/enums/ActionTypes/EditsActions'
import {appLayersDispatcher} from './appLayersDispatcher'
import {getMapService} from '../core/reducers/map'
class AppEditsDispatcher extends EditsDispatcher {
  layersDispatcher: ILayersDispatcher
  constructor(layersDispatcher: ILayersDispatcher) {
    super()
    this.layersDispatcher = layersDispatcher
  }
  protected tryThrowApplyEditsError(applyEditsFilter: ISourceApplyEdits[], currentEdits: TypeKeyIdFeaturesPair): void {
    applyEditsFilter.forEach(a => {
      const storeSourceEdits = currentEdits[a.layerInfo.url]
      if (appConfig.reg.regrelated.indexOf(a.layerInfo.url) != -1) {
        return
      }
      // if(a.adds && a.adds.length > 0){
      //     if(!storeSourceEdits){
      //         // throw new Error(`Cant find ${a.layerInfo.url} in store.edits.edits`);
      //     }
      //     a.adds.forEach(add => {
      //         if(!storeSourceEdits[add.getId()]){
      //             throw new Error(`Cant find ${add.getId()} from adds in store.edits.edits[${a.layerInfo.url}]`);
      //         }
      //     })
      // }

      // if(this.props.layerInfo.sourceDescription.id == appConfig.reg.site.id){
      //     this.props.feature.set("PR5", "%%%%%")
      //     this.props.editsDispatcher!.applyChanges({[appConfig.reg.site.id]: {[this.props.feature.getId()]: this.props.feature}})
      // }
      if (a.updates && a.updates.length > 0) {
        if (!storeSourceEdits) {
          throw new Error(`Cant find ${a.layerInfo.url} in store.edits.edits`)
        }
        a.updates.forEach(update => {
          if (!storeSourceEdits[update.getId()]) {
            throw new Error(`Cant find ${update.getId()} from updates in store.edits.edits[${a.layerInfo.url}]`)
          }
        })
      }
    })
  }

  public cancel(filter?: TypeKeyIdFeaturesPair) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const sourcesEdits: TypeKeyIdFeaturesPair = {}
      const changes = getStore().edits
      if (!filter) {
        filter = {...changes.edits}
      }
      const edits = {...changes.edits}
      let hasSite = false
      for (const id in changes.originals) {
        if (filter[id]) {
          sourcesEdits[id] = {}
          for (const featId in changes.originals[id]) {
            if (filter[id][featId]) {
              if (edits[id] && edits[id][featId]) {
                delete edits[id][featId]
              }
              if (changes.originals[id][featId]) {
                if (changes.originals[id][featId].status == FeatureStatus.New) {
                  //not sure if I should just remove the new fearutes everywhere on cancel...
                  changes.originals[id][featId].status = FeatureStatus.Deleted
                }
                if (id == appConfig.reg.site.id) {
                  hasSite = true
                }
                sourcesEdits[id][featId] = changes.originals[id][featId]
              }
            }
          }
          if (edits[id] && Object.keys(edits[id]).length == 0) {
            delete edits[id]
          }
        }
      }
      if (hasSite) {
        getMapService()
          .getLayers()
          .filter(l => l.moreInfo.urls.indexOf(appConfig.reg.site.id) != -1)
          .forEach(l => {
            l.setOpacity(0)
          })
        getMapService()
          .getLayers()
          .filter(l => l.moreInfo.urls.indexOf(appConfig.reg.siteLine.id) != -1)
          .forEach(l => {
            l.setOpacity(1)
          })
      }
      dispatch({
        type: EditsActions.SET_SOURCE_EDITS,
        payload: edits
      })
      dispatch(this.dispatchAll(sourcesEdits))
    }
  }

  public setOriginals(originalFeatures: TypeKeyIdFeaturesPair, callback: () => void) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const editsStore = getStore().edits
      const originals: TypeKeyIdFeaturesPair = {}
      let hasSite = false
      for (const id in originalFeatures) {
        const idFeatures: IdFeature = {...editsStore.originals[id]}
        for (const key in originalFeatures[id]) {
          const f = originalFeatures[id][key]
          if (id == appConfig.reg.site.id) {
            hasSite = true
          }
          if (f.status == FeatureStatus.Modified) {
            alert("Can't set originals from modified entity")
            throw new Error('Cant set originals from modified entity')
          }
          idFeatures[f.getId()] = f.clone()
        }
        originals[id] = idFeatures
      }

      dispatch({
        type: EditsActions.ADD_OR_UPDATE_SOURCE_ORIGINALS,
        payload: originals
      })
      if (hasSite) {
        getMapService()
          .getLayers()
          .filter(l => l.moreInfo.urls.indexOf(appConfig.reg.site.id) != -1)
          .forEach(l => {
            l.setOpacity(1)
          })
        getMapService()
          .getLayers()
          .filter(l => l.moreInfo.urls.indexOf(appConfig.reg.siteLine.id) != -1)
          .forEach(l => {
            l.setOpacity(0)
          })
      }
      setTimeout(() => {
        callback()
      }, 100)
    }
  }
}

export const appEditsDispatcher = new AppEditsDispatcher(appLayersDispatcher) as IEditsDispatcher
